import { useState } from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { useMediaQuery } from "@mui/material";
import emailjs from 'emailjs-com'
import Button from '@mui/material/Button';
import SendIcon from '@mui/icons-material/Send';

const Contact = () => {
    const [sendForm, setSendForm] = useState(false);
    const space = useMediaQuery('(max-width:600px)')
    const user_id = '5as1F1QS06mSY93k-';
    const template_id = 'template_cng3vyv';
    const service_id = 'service_1tq4ze5';

    return (
        <div className="container-fluid m-5 text-white">
            {
                space && <div className="mt-4"></div>
            }
            <h1 className="divTitle">Contact Me:</h1>
            <div className="w-100 d-flex flex-column align-items-center">
                <Formik
                    validate={({ name, email, message }) => {
                        let errors = {}

                        //VALIDACION NOMBRE
                        if (!name) {
                            errors.name = 'Please enter a name'
                        } else if (!/^[a-zA-ZÀ-ÿ\s]{1,40}$/.test(name)) {
                            errors.name = 'The name can only contain letters and spaces'
                        }
                        //VALIDACION EMAIL
                        if (!email) {
                            errors.email = 'Please enter an email'
                        } else if (!/^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/.test(email)) {
                            errors.email = 'Email can only have letters, numbers, dots, dashes, and underscores.'
                        }
                        //VALIDACION MESSAGE
                        if (!message) {
                            errors.message = 'Plese live a message'
                        }
                        return errors
                    }}
                    initialValues={{
                        name: '',
                        email: '',
                        message: ''
                    }}
                    onSubmit={(values, { resetForm }) => {
                        console.log(values)
                        resetForm()
                        setSendForm(true)
                        setTimeout(() => setSendForm(false), 5000)
                        emailjs.send(service_id, template_id, values, user_id).then(res => console.log)
                    }}
                >
                    {({ errors }) => (
                        <Form action="https://formsubmit.co/ulisescatarinolo@outlook.com" method="post" className="formContainer">
                            <div className="m-2">
                                <label htmlFor="name">Name</label>
                                <Field
                                    type="text"
                                    name="name"
                                    id="name"
                                    className="form-control bg-dark text-white"
                                    placeholder="John Doe"
                                />
                                <ErrorMessage name="name" component={() => (
                                    <p className="text-danger">{errors.name}</p>
                                )} />
                            </div>
                            <div className="m-2">
                                <label htmlFor="email">Email</label>
                                <Field
                                    type="text"
                                    name="email"
                                    id="email"
                                    className="form-control bg-dark text-white"
                                    placeholder="johndoe@hotmail.com"
                                />
                                <ErrorMessage name='email' component={() => (
                                    <p className="text-danger">{errors.email}</p>
                                )} />
                            </div>
                            <div className="m-2">
                                <label htmlFor="message">Message</label>
                                <Field
                                    as='textarea'
                                    name="message"
                                    id="message"
                                    className="form-control bg-dark text-white"
                                    placeholder="Leave a message"
                                    cols="20"
                                    rows="5"
                                />
                                <ErrorMessage name='message' component={() => (
                                    <p className="text-danger">{errors.message}</p>
                                )} />
                            </div>
                            <div className="d-flex flex-column align-items-center">
                                <Button className="w-50" type="submit" variant="contained" endIcon={<SendIcon />}>
                                    Send
                                </Button>
                                {sendForm && <p className="text-success mt-2">Submitted form!</p>}
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        </div>
    );
}

export default Contact;